<div
  [ngClass]="{
    'margin-inline': !isFlexCentered,
    'flex-centered': isFlexCentered
  }">
  <div
    data-testid="htc-expandable-content-container"
    class="expandable-content-container"
    #expandableContentContainer>
    <button
      [disabled]="disabled"
      data-testid="htc-expandable-content-button"
      class="expandable-content-button"
      (click)="openModal()">
      <ng-content></ng-content>
    </button>
    @if (!disabled) {
      <svg-icon
        data-testid="htc-expandable-icon"
        class="expandable-icon"
        [attr.aria-label]="'HINTS.TABLE_EXPAND_ICON' | translate"
        src="assets/button-icons/big.svg"
        [ngStyle]="{
          transform: 'scale(' + 1 / scaledValue + ')'
        }"></svg-icon>
    }
  </div>
</div>
